module.exports = __webpack_public_path__ + "static/media/Smiley_rechterarm_unhappy.ea97e8bb.png";